<template>
	<el-container class="fullheight">
		<iframe  style="height:100%;width:100%;border:0px" src="" name="f1">
		</iframe>
		<form :action="actionUrl" ref="form" name="formTest" method="post" target='f1'>
			<input type="hidden" name="fr_username" :value="userAccount"/>
			<input type="hidden" name="userAccount" :value="userAccount"/>
			<input type="hidden" name="DTID" :value="dtid"/>
		</form>
	</el-container>
</template>

<script>
export default {
	name: 'templateReport',
	props:['alias'],
	data() {
		return {
			actionUrl:""//报表地址
		};
	},
	created(){
		this.userId=this.$store.state.login.currentUser.userId;
		this.userAccount=this.$store.state.login.currentUser.account;
		this.dtid = sessionStorage.getItem('dtid');
	},
	mounted(){
		if (this.alias){
			this.$store.dispatch("menu/getReportServerUrl",this.alias).then(res=>{
				this.$refs.form.action=decodeURIComponent(res.value);
				this.$refs.form.submit();
			});
		}
	},
	watch:{
		alias:{
			handler(newVal){
				if (newVal){
					this.$store.dispatch("menu/getReportServerUrl",newVal).then(res=>{
						this.$refs.form.action=decodeURIComponent(res.value);
						this.$refs.form.submit();
					});
				}
			}
		}
	},

}
</script>

<style lang="scss" scoped>
	.tab-container {
		height: 800px;
		background-color: #fff;
		padding: 10px;
	}
</style>
